export const LOAD_ALLOWED_COVID19_FEATURES_SUCCESS = "LOAD_ALLOWED_COVID19_FEATURES_SUCCESS";

export const LOAD_ALLOWED_COVID19_FEATURES = "LOAD_ALLOWED_COVID19_FEATURES";
